<template>
  <v-card flat>
    <v-stepper
      v-model="messengerActiveStep"
      vertical
      class="custom-header"
      non-linear
      flat
    >
      <v-form
        ref="formRef"
        class="multi-col-validation"
        @submit.prevent="handleSubmit"
      >
        <v-stepper-step
          editable
          :complete="messengerActiveStep > 1"
          step="1"
        >
          <div class="d-flex align-center">
            <span class="text--primary text-4xl font-weight-bold me-3">01</span>
            <div class="d-flex flex-column">
              <span class="text--primary text-sm font-weight-semibold">Identificador página</span>
              <span class="text--secondary text-xs">Digite o Identificador Página do seu chatbot</span>
            </div>
          </div>
        </v-stepper-step>

        <v-stepper-content step="1">
          <v-col
            cols="12"
          >
            <v-text-field
              v-model="chatBotMessengerDataLocale.identificadorPagina"
              dense
              outlined
              label="Identificador página"
              hint="Máximo de 300 caracteres"
              validate-on-blur
              :rules="[validators.required, v => (!!v && v.length <= 300) || 'Máximo de 300 caracteres']"
            />
            <v-btn
              color="primary"
              class="mt-2"
              @click="messengerNextStep"
            >
              Próximo
            </v-btn>
          </v-col>
        </v-stepper-content>

        <v-stepper-step
          :complete="messengerActiveStep > 2"
          editable
          step="2"
        >
          <div class="d-flex align-center">
            <span class="text--primary text-4xl font-weight-bold me-3">02</span>
            <div class="d-flex flex-column">
              <span class="text--primary text-sm font-weight-semibold">Token Acesso Página</span>
              <span class="text--secondary text-xs">Digite o Token Acesso Página do seu chatbot</span>
            </div>
          </div>
        </v-stepper-step>

        <v-stepper-content step="2">
          <v-col
            cols="12"
          >
            <v-text-field
              v-model="chatBotMessengerDataLocale.tokenAcessoPagina"
              dense
              outlined
              label="Token Acesso Página"
              hint="Máximo de 1000 caracteres"
              validate-on-blur
              :rules="[validators.required, v => (!!v && v.length <= 1000) || 'Máximo de 1000 caracteres']"
            />
            <div class="mt-2">
              <v-btn
                outlined
                class="mr-2"
                @click="messengerPreviousStep"
              >
                Voltar
              </v-btn>
            </div>
          </v-col>
        </v-stepper-content>

        <div class="d-flex justify-center flex-wrap py-2 my-2">
          <v-btn
            outlined
            @click="resetData"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="success"
            class="ms-2"
            :loading="loading"
            type="submit"
          >
            {{ isChatBotMessengerNovo ? 'Criar' : 'Salvar' + ' Messenger' }}
          </v-btn>
        </div>
      </v-form>
    </v-stepper>
  </v-card>
</template>

<script>
import Vue from 'vue'
import { ref, watch, inject, computed } from '@vue/composition-api'
import { required, select } from '@core/utils/validation'
import ChatBotService from '@/services/modules/ChatBotService'
import useForm from '@/composables/useForm'

export default {
  props: {
    chatBotId: {
      type: Number,
      required: true,
    },
  },
  setup(props, { emit }) {
    const messengerActiveStep = ref(1)

    const chatBotMessengerData = inject('chatBotMessengerData')
    const chatBotMessengerDataLocale = ref({})
    watch(() => chatBotMessengerData.value, value => { chatBotMessengerDataLocale.value = value }, { immediate: true, deep: true })

    const isChatBotMessengerNovo = computed(() => !chatBotMessengerData.value.id)
    watch(() => isChatBotMessengerNovo.value, value => { if (!value) messengerActiveStep.value = 2 }, { immediate: true, deep: true })

    function getMessengerRequestBody() {
      return {
        identificadorPagina: chatBotMessengerDataLocale.value.identificadorPagina,
        tokenAcessoPagina: chatBotMessengerDataLocale.value.tokenAcessoPagina,
      }
    }

    const { formRef, loading, resetForm } = useForm()

    async function updateMessengerChatBot() {
      try {
        loading.value = true
        await ChatBotService.updateConfigMessenger(props.chatBotId, getMessengerRequestBody())
        emit('update:chat-bot-id', props.chatBotId)
        loading.value = false
      } catch {
        loading.value = false
      }
    }

    function resetData() {
      resetForm()
      emit('reset-data')
    }

    async function handleSubmit() {
      if (loading.value) return
      if (formRef.value.validate()) {
        updateMessengerChatBot()
      } else {
        Vue.$toast.warning('Preencha corretamente os campos antes de salvar')
      }
    }

    function messengerNextStep() {
      // eslint-disable-next-line no-plusplus
      messengerActiveStep.value++
    }

    function messengerPreviousStep() {
      // eslint-disable-next-line no-plusplus
      messengerActiveStep.value--
    }

    return {
      chatBotMessengerDataLocale,
      isChatBotMessengerNovo,
      resetData,
      handleSubmit,
      messengerActiveStep,
      messengerNextStep,
      messengerPreviousStep,
      loading,
      formRef,
      validators: {
        required,
        select,
      },
    }
  },
}
</script>
